import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useTheme } from '@/context/ThemeContext';
interface ThemeToggleProps {
  compact?: boolean;
  showLabel?: boolean;
}
export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  compact = false,
  showLabel = false
}) => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  if (compact) {
    return <div className="flex flex-col items-center gap-2">
        {theme === 'dark' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
        <Switch checked={theme === 'dark'} onCheckedChange={toggleTheme} aria-label="Basculer le thème" />
      </div>;
  }
  return (
    <div className="flex items-center gap-3">
      {theme === 'dark' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <Switch 
        checked={theme === 'dark'} 
        onCheckedChange={toggleTheme} 
        aria-label="Basculer le thème" 
      />
      {showLabel && (
        <span className="text-sm font-medium">
          {theme === 'dark' ? 'Sombre' : 'Clair'}
        </span>
      )}
    </div>
  );
};